import * as React from 'react';
import { Badge, BadgeProps } from 'reactstrap';
import './status.scss';

type StatusProps = {
    id?: string;
    pill?: boolean;
    clsPrefix?: string;
} & BadgeProps;

export default class Status extends React.PureComponent<StatusProps, {}> {
    public render() {
        const { id, color, pill, clsPrefix, onClick, className, ...rest } = this.props;
        const classNames = ['status'];
        if(clsPrefix) classNames.push(clsPrefix);
        if(className) classNames.push(className);

        return (
            <Badge id={id} color={color} className={classNames.join(' ')} pill={pill} onClick={onClick} {...rest}>
                {this.props.children}
            </Badge>
        );
    }
}
